import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimacionContacto = () => {
  useEffect(() => {
    gsap.context(() => {
      const tl = gsap
        .timeline({
          delay: 0.5
        })
        .fromTo(
          '.tapa-js',
          {
            scaleY: -1.5
          },
          {
            scaleY: 1,
            duration: 0.5,
            ease: 'power2.out'
          }
        )
        .fromTo(
          '.airplane-js',
          {
            x: 0
          },
          {
            x: 100,
            ease: 'back.in'
          }
        )
        .to('.airplane-js', {
          x: 1000,
          y: -150,
          rotate: '-15deg',
          scale: 0,
          autoAlpha: 0,
          ease: 'none',
          duration: 1
        });
    });
  }, []);

  return (
    <>
      <div className="relative z-2 w-200 sm:w-295 h-300 sm:h-360 sm:mr-15">
        <Image
          src="/images/contact/woman.svg"
          width={295}
          height={360}
          alt=""
          className="w-200 sm:w-295 object-cover"
        />
        <Image
          src="/images/contact/buzontapa.svg"
          width={41}
          height={26}
          alt=""
          className="absolute z-1 w-34 sm:w-41 top-[38%] left-[10%] sm:top-[47.5%] sm:left-[12%] origin-top tapa-js"
        />
        <Image
          src="/images/contact/airplane.svg"
          width={108}
          height={62}
          alt=""
          className="absolute z-1 w-45 sm:w-110 top-[12%] right-[13%] sm:top-[11%] sm:right-[-1%] airplane-js"
        />
      </div>
    </>
  );
};
export default AnimacionContacto;
